/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolFilterScope,
  ToolFilterScope$inboundSchema,
} from "./toolfilterscope.js";
import {
  ToolFilterTool,
  ToolFilterTool$inboundSchema,
} from "./toolfiltertool.js";

/**
 * The tool filtering configuration in effect for an MCP server: the resolved tool variations group, the available filter scopes (tags), and the tools excluded from all filters. Read-only. Filtering is reported as enabled only when an explicit tool variations group is configured on the MCP server or its toolset; the per-group effective-tag derivation matches the runtime ?tags= filter for that group.
 */
export type ListToolFiltersResult = {
  /**
   * Tools whose effective tag set is empty: reachable only without a ?tags= filter.
   */
  excluded: Array<ToolFilterTool>;
  /**
   * Whether tool filtering is enabled, i.e. the resolution chain (mcp_servers then toolsets) yields a non-null tool variations group. When false, scopes and excluded are empty. A project-default (source-level) variations group is not treated as filtering here.
   */
  filteringEnabled: boolean;
  /**
   * The available filter scopes (tags), each with its member tools. Union of effective tags across the server's tools.
   */
  scopes: Array<ToolFilterScope>;
  /**
   * The ID of the resolved tool variations group, if filtering is enabled.
   */
  toolVariationsGroupId?: string | undefined;
  /**
   * The name of the resolved tool variations group, if filtering is enabled.
   */
  toolVariationsGroupName?: string | undefined;
};

/** @internal */
export const ListToolFiltersResult$inboundSchema: z.ZodMiniType<
  ListToolFiltersResult,
  unknown
> = z.pipe(
  z.object({
    excluded: z.array(ToolFilterTool$inboundSchema),
    filtering_enabled: z.boolean(),
    scopes: z.array(ToolFilterScope$inboundSchema),
    tool_variations_group_id: z.optional(z.string()),
    tool_variations_group_name: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "filtering_enabled": "filteringEnabled",
      "tool_variations_group_id": "toolVariationsGroupId",
      "tool_variations_group_name": "toolVariationsGroupName",
    });
  }),
);

export function listToolFiltersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolFiltersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolFiltersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolFiltersResult' from JSON`,
  );
}
